export default {
  name: 'vue-treeselect--x'
};